import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_VANTIVE_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_VANTIVE,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_VANTIVE_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_VANTIVE_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_VANTIVE_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  VANTIVE_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  VANTIVE_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_VANTIVE,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  VANTIVE_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_VANTIVE,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Cổng thông tin phản hồi về sản phẩm";
translations[LANDING_BRIEF] = "Cổng thông tin trực tuyến phản hồi về sản phẩm của Vantive nhằm thu thập những thông tin bảo mật và phản hồi về các sản phẩm của Vantive.";
translations[LANDING_LANGUAGE_SELECTOR] = "Chọn ngôn ngữ ưu tiên";
translations[LANDING_COUNTRY_SELECTOR] = "Chọn Quốc gia xảy ra sự cố";
translations[LANDING_TERMS] = "Tôi đã đọc và đồng ý với Điều khoản về sử dụng và xác nhận bảo mật thông tin cá nhân ";
translations[LANDING_TERMS_ERROR] = "Bạn cần đọc và đồng ý với nội dung của Điều khoản sử dụng, Chính sách bảo mật, Điều khoản sử dụng bổ sung cho Cổng thông tin phản hồi về sản phẩm của Vantive, Chính sách bảo mật cho Cổng thông tin phản hồi về sản phẩm của Vantive.";
translations[LANDING_CAPTCHA_ERROR] = "Xin xác nhận bạn không phải là robot.";
translations[APP_DESCRIPTION] = "Cổng thông tin trực tuyến phản hồi về sản phẩm của Vantive nhằm thu thập thông tin về sản phẩm. Nếu bạn gặp bất kỳ vấn đề nào với sản phẩm của Vantive, chúng tôi khuyến khích bạn chia sẻ thêm thông tin chi tiết. Tất cả phản hồi của bạn đều cần thiết để chúng tôi hoàn thành mục tiêu chung là không ngừng phát triển sản phẩm và sự hài lòng của khách hàng.";
translations[LANDING_TERMS_I_HAVE_READ] = "Tôi đã đọc Thông báo về quyền riêng tư được liên kết cho Cổng thông tin phản hồi về sản phẩm Vantive và hiểu rằng Vantive Healthcare Corporation (“Vantive”) đang tìm kiếm sự đồng ý của tôi để sử dụng, tiết lộ và xử lý dữ liệu cá nhân của tôi cho các mục đích và như được mô tả trong Thông báo về quyền riêng tư. Tôi đồng ý với:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "Việc sử dụng, tiết lộ, lưu trữ và xử lý dữ liệu cá nhân của tôi (bao gồm bất kỳ dữ liệu nhạy cảm nào, chẳng hạn như dữ liệu liên quan đến sức khỏe, mà tôi chọn cung cấp) cho các mục đích được nêu trong Thông báo về Quyền riêng tư.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Việc chuyển dữ liệu cá nhân của tôi (bao gồm cả dữ liệu nhạy cảm, chẳng hạn như dữ liệu liên quan đến sức khỏe, mà tôi chọn cung cấp) ra khỏi quốc gia của tôi và đến một quốc gia khác có thể có luật bảo vệ dữ liệu ít nghiêm ngặt hơn hoặc không có.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Tôi hiểu rằng sự đồng ý này là tự nguyện và tôi có thể thay đổi quyết định bất cứ lúc nào và thu hồi sự đồng ý của mình bằng cách liên hệ với Vantive bằng các chi tiết liên hệ được cung cấp trong Thông báo về Quyền riêng tư. Tôi hiểu rằng việc rút lại sự đồng ý của tôi sẽ không ảnh hưởng đến tính hợp pháp của quá trình xử lý trước khi rút lại.";
translations[MENU_FEEDBACK_FORM] = "Bắt đầu một phản hồi về sản phẩm";
translations[MENU_FEEDBACK_STATUS] = "Kiểm tra trạng thái phản hồi về sản phẩm";
translations[MENU_FORM_INTAKE] = "Người báo cáo/Thông tin liên hệ";
translations[MENU_FORM_EVENT_DETAILS] = "Chi tiết sự việc";
translations[MENU_FORM_PRODUCT_INFO] = "Thông tin sản phẩm";
translations[SYSTEM_FEEDBACK_FORM] = "Mở mẫu phản hồi sản phẩm";
translations[SYSTEM_FEEDBACK_STATUS] = "Kiểm tra trạng thái phản hồi về sản phẩm";
translations[SUBMIT_FEEDBACK] = "Bấm vào đây để gửi phản hồi";
translations[CHECK_SUBMITTED_FEEDBACK] = "Bấm vào đây để kiểm tra trạng thái của phản hồi đã gửi";
translations[BTN_LAUNCH_FORM] = "Mở mẫu";
translations[BTN_CHECK_STATUS] = "Kiểm tra trạng thái";
translations[FORM_TITLE] = "Mẫu phản hồi về sản phẩm";
translations[FORM_SUB_TITLE] = "Nếu có nhiều bệnh nhân liên quan, vui lòng điền 1 mẫu cho mỗi bệnh nhân";
translations[FORM_MANDATORY_FIELDS] = "Tất cả những ô có dấu * là bắt buộc";
translations[BUTTON_PREV] = "Trước đó";
translations[BUTTON_NEXT] = "Tiếp theo";
translations[BUTTON_SUBMIT] = "Gửi";
translations[SELECT_RESPONSE] = "Chọn câu trả lời";
translations[FUNCTION_ROLE] = "Chức năng/Vai trò";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Số tài khoản của khách hàng";
translations[ENTER_CUSTOMER_ACCOUNT] = "Nhập tài khoản khách hàng";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Số tài khoản của khách hàng liên quan đến sự việc được báo cáo?";
translations[EVENT_REPORTED] = "Sự việc này đã được báo cáo trước đó chưa (tới Vantive hoặc bất cứ tổ chức nào)?";
translations[REFERENCE_NUMBER] = "Mã số tham khảo liên quan đến sự việc này";
translations[ENTER_REFERENCE] = "Nhập tham khảo";
translations[WHO_REPORTED_TO] = "Sự việc này đã được báo cáo cho ai?";
translations[WHO_WAS_NOTIFIED] = "Xin cung cấp tên của người được thông báo?";
translations[ENTER_NAME] = "Nhập tên";
translations[YOUR_NAME] = "Tên của bạn";
translations[OCCUPATION] = "Nghề nghiệp";
translations[PHONE_NUMBER] = "Số điện thoại";
translations[ENTER_PHONE_NUMBER] = "Nhập số điện thoại";
translations[ENTER_EMAIL] = "Nhập email";
translations[EMAIL_ADDRESS] = "Địa chỉ email";
translations[ENTER_ADDRESS] = "Nhập địa chỉ email";
translations[ENTER_NA_IF_UNKNOWN] = "Nhập NA nếu không biết";
translations[FACILITY_HOSPITAL] = "Tên cơ sở/Bệnh viện hoặc nhà phân phối (nếu áp dụng)";
translations[ENTER_FACILITY] = "Nhập cơ sở";
translations[ADDRESS_1] = "Địa chỉ 1";
translations[ADDRESS_2] = "Địa chỉ 2";
translations[CITY] = "Thành phố";
translations[STATE] = "Bang";
translations[POSTAL_CODE] = "Mã bưu điện";
translations[COUNTRY] = "Quốc gia ";
translations[END_USER_CUSTOMER] = "Sự việc này được phát hiện bởi một bệnh nhân/khách hàng?";
translations[ADDITIONAL_CONTACT_PERSON] = "Thông tin liên lạc bổ sung";
translations[ADDITIONAL_PHONE] = "Số điện thoại liên lạc bổ sung";
translations[ADDITIONAL_EMAIL] = "Địa chỉ thư điện tử bổ sung";
translations[ANOTHER_FACILITY_ADDRESS] = "Thêm một cơ sở/địa chỉ khác";
translations[ANOTHER_FACILITY_HOSPITAL] = "Tên một Cơ sở/Bệnh viện hay nhà phân phối khác (nếu áp dụng)";
translations[ANOTHER_ENTER_FACILITY] = "Nhập cơ sở";
translations[ANOTHER_ADDRESS_1] = "Địa chỉ 1";
translations[ANOTHER_ADDRESS_2] = "Địa chỉ 2";
translations[ANOTHER_CITY] = "Thành phố";
translations[ANOTHER_STATE] = "Bang";
translations[ANOTHER_POSTAL_CODE] = "Mã bưu điện";
translations[ANOTHER_COUNTRY] = "Quốc gia ";
translations[LOT_SERIAL_NUMBER] = "Số lô/Số seri";
translations[ENTER_LOT_SERIAL_NUMBER] = "Nhập số lô/số seri";
translations[HELP_LOT_SERIAL_NUMBER] = "Nhập Không biết nếu bạn không biết số lô/số seri, hoặc Đã hỏi nhưng Không biết nếu bạn đã hỏi người báo cáo và họ không biết.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Mã sản phẩm";
translations[PRODUCT_CODE] = "Mã sản phẩm";
translations[ENTER_PRODUCT_CODE] = "Nhập mã số sản phẩm";
translations[HELP_PRODUCT_CODE] = "Nhập Không biết nếu bạn không biết số mã sản phẩm, hoặc Đã hỏi nhưng Không biết nếu bạn đã hỏi người báo cáo và họ không biết.";
translations[NDC] = "Mã số thuốc quốc gia (NDC)";
translations[ENTER_NDC] = "Nhập NDC";
translations[UDI] = "Mã số nhận dạng thiết bị (UDI)";
translations[ENTER_UDI] = "Nhập UDI";
translations[PRODUCT_NAME] = "Tên sản phẩm";
translations[ENTER_PRODUCT_NAME] = "Nhập tên sản phẩm";
translations[HELP_PRODUCT_NAME] = "Cung cấp tên hoặc chỉ định của sản phẩm";
translations[BEST_DESCRIBES] = "Vui lòng chọn mô tả phù hợp nhất với vấn đề được báo cáo";
translations[QUANTITY_TO_SELECT] = "Lựa chọn số lượng";
translations[ENTER_QUANTITY] = "Nhập số lượng";
translations[HELP_QUANTITY] = "Số lượng sản phẩm gặp sự cố";
translations[UNIT] = "Đơn vị";
translations[AVAILABLE_TO_RETURNED] = "Sản phẩm thực tế bị sự cố có thể gửi trả cho Vantive để đánh giá không?";
translations[PHOTOGRAPH_AVAILABLE] = "Bạn có hình ảnh hoặc video của sản phẩm không?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Đảm bảo rằng sự cố đã báo cáo có thể thấy rõ trong hình ảnh hoặc video.";
translations[UPLOAD_IMAGES] = "Tải hình ảnh lên";
translations[REPORTER_NAME] = "Tên người báo cáo";
translations[REPORTER_FACILITY] = "Tổ chức của người báo cáo";
translations[REPORTER_OCCUPATION] = "Nghề nghiệp của người báo cáo";
translations[ENTER_NUMBER] = "Nhập số";
translations[REPORTER_PHONE_NUMBER] = "Số điện thoại của người báo cáo";
translations[REPORTER_EMAIL_ADDRESS] = "Địa chỉ email của người báo cáo";
translations[EMPLOYEE_NAME] = "Tên nhân viên";
translations[EMPLOYEE_PHONE_NUMBER] = "Số điện thoại nhân viên";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Địa chỉ email của nhân viên";
translations[RETURNING_FOR_INVESTIGATION] = "Bạn sẽ trả lại bao nhiêu sản phẩm mẫu (theo đơn vị cái/chiếc) bị sự cố?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Những mẫu này phải là sản phẩm gặp sự cố đã báo cáo";
translations[UNUSED_VANTIVE_PRODUCT] = "Bạn có thể gửi trả MỘT sản phẩm chưa sử dụng có cùng số lô cho Vantive để đánh giá không?";
translations[YOU_INDICATED_SAMPLES] = "Bạn đã khẳng định sản phẩm mẫu có sẵn để đánh giá, bạn có thể mang sản phẩm này tới nhân viên y tế của bạn không?";
translations[SAMPLE_RETURN_KIT] = "Bạn đã khẳng định sản phẩm mẫu có sẵn để đánh giá, vui lòng xác nhận lại địa chỉ để gửi lại bộ sản phẩm";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Một hộp có nhãn đã trả trước sẽ được gửi đến địa chỉ này để gửi trả mẫu";
translations[SAME_AS_MY_ADDRESS] = "Giống Địa chỉ của tôi";
translations[OTHER_CONTACT_NAME] = "Tên người liên lạc khác";
translations[OTHER_CONTACT_OCCUPATION] = "Nghề nghiệp của người liên lạc khác";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Số điện thoại của người liên lạc khác";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Địa chỉ email của người liên lạc khác";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Sản phẩm bạn lựa chọn được sản xuất bởi một công ty khác, nếu họ có thêm câu hỏi về báo cáo của bạn, chúng tôi có thể chia sẻ thông tin liên hệ của bạn với họ không?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Khách hàng có yêu cầu cụ thể việc thông báo kết quả phân tích khiếu nại không?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Khách hàng có yêu cầu cụ thể việc hoàn tiền không?";
translations[PRODUCT_FROM_VANTIVE] = "Khách hàng có đặt hàng trực tiếp từ Vantive không?";
translations[QUANTITY_REQUESTED_CREDIT] = "Số lô và số lượng được yêu cầu hoàn tiền:";
translations[ENTER_OCCUPATION] = "Nhập nghề nghiệp";
translations[LOT_QUANTITY_NUMBER] = "Nhập số lô và số lượng";
translations[WHOLESALERS_NAME] = "Tên của nhà bán buôn và địa điểm (thành phố, quận huyện)";
translations[PLACE_WHOLESALERS_NAME] = "Tên của nhà bán buôn và địa điểm (thành phố, quận huyện)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Thêm sản phẩm vào bảng";
translations[SAVE] = "Lưu";
translations[CANCEL] = "Hủy";
translations[ADD_MORE_PRODUCTS] = "Thêm sản phẩm khác";
translations[REPORTER_ADDRESS] = "Địa chỉ của người báo cáo";
translations[ATTACHMENTS] = "Tập tin đính kèm";
translations[DATE_OF_EVENT] = "Ngày xảy ra sự việc";
translations[DATE_OF_EVENT_MSG] = "Ngày sự việc xảy ra không thể sau ngày thông báo cho nhân viên Vantive. Vui lòng nhập một ngày hợp lệ";
translations[HELP_DATE_OF_EVENT] = "Nếu có nhiều hơn một ngày có sự cố xảy ra, vui lòng điền một mẫu cho mỗi ngày";
translations[DATE_VANTIVE_EMPLOYEE] = "Ngày nhân viên của Vantive được thông báo về sự việc";
translations[DURING_WHAT_PROCESS] = "Sự việc xảy ra ở bước nào?";
translations[WAS_THE_PATIENT] = "Tại thời điểm xảy ra sự việc, có bệnh nhân đang được điều trị không?";
translations[WERE_YOU_CONNECTED] = "Bạn có đang kết nối (đang trị liệu) tại thời điểm xảy ra sự cố không?";
translations[PROVIDE_ANY_ADDITIONAL] = "Vui lòng cung cấp thêm chi tiết về sự việc/sự cố";
translations[HELP_YOU_IDENTIFIED_MORE] = "Bạn đã xác định nhiều hơn một sản phẩm và sự cố, vui lòng làm rõ sản phẩm nào gặp sự cố nào";
translations[ENTER_DETAILS] = "Nhập thông tin chi tiết";
translations[PROVIDE_ANY_ATTACHMENT] = "Vui lòng cung cấp tập tin đính kèm (nếu có)";
translations[WAS_NEGATIVE_MEDICAL] = "Sự việc có gây ra tác động y khoa, triệu chứng, hay tổn thương nào không?";
translations[WAS_MEDICAL_INTERVENTION] = "Trị liệu, can thiệp y khoa hoặc chăm sóc đặc biệt đã thực hiện để khắc phục sự cố";
translations[PROVIDE_DETAILS] = "Xin cung cấp chi tiết";
translations[REQUIRED_TREATMENT] = "Can thiệp y khoa/phương pháp điều trị cần thiết";
translations[ENTER_TREATMENT] = "Nhập biện pháp điều trị";
translations[RELEVANT_TESTS] = "Các xét nghiệm có liên quan, bao gồm cả dữ liệu từ phòng xét nghiệm";
translations[HELP_RELEVANT_TESTS] = "Nhập các xét nghiệm liên quan";
translations[RELEVANT_MEDICAL_HISTORY] = "Bệnh sử có liên quan, bao gồm các tình trạng y khoa có sẵn";
translations[ENTER_HISTORY] = "Nhập lịch sử";
translations[PATIENT_NAME] = "Tên bệnh nhân";
translations[PATIENT_INITIALS] = "Tên viết tặt hoặc tên đầy đủ của bệnh nhân. Nếu có nhiều bệnh nhân liên quan, vui lòng điền 1 mẫu cho mỗi bệnh nhân";
translations[PATIENT_PHONE_NUMBER] = "Số điện thoại bệnh nhân";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Tôi không muốn cung cấp";
translations[PATIENT_EMAIL_ADDRESS] = "Địa chỉ email của bệnh nhân";
translations[PATIENT_ADDRESS] = "Địa chỉ bệnh nhân";
translations[SAME_ADDRESS] = "Cùng địa chỉ";
translations[DRUG_BEING_USED] = "Tại thời điểm xảy ra sự việc, có thuốc của Vantive được sử dụng không?";
translations[PATIENT_IDENTIFIER] = "Thông tin bệnh nhân";
translations[PATIENT_AGE_OR_DOB] = "Tuổi bệnh nhân hoặc DOB";
translations[ENTER_PATIENT_AGE] = "TT/NN/NNNN, Nhập tuổi bệnh nhân";
translations[PATIENT_GENDER] = "Giới tính bệnh nhân";
translations[PATIENT_WEIGHT] = "Cân nặng của bệnh nhân";
translations[ENTER_WEIGHT] = "Nhập cân nặng";
translations[PATIENT_WEIGHT_UNIT] = "Đơn vị tính cân nặng";
translations[MY_NAME] = "Tên của tôi";
translations[ENTER_IN_YOUR_CONTACT] = "Nhập thông tin liên lạc của bạn";
translations[MY_PHONE_NUMBER] = "Số điện thoại của tôi";
translations[MY_EMAIL_ADDRESS] = "Địa chỉ email của tôi";
translations[MY_ADDRESS] = "Địa chỉ của tôi";
translations[NAME_OF_VANTIVE_DRUG] = "Tên thuốc của Vantive";
translations[ENTER_DRUG_NAME] = "Nhập tên thuốc";
translations[PLEASE_PROVIDE_THE_NAME] = "Vui lòng cung cấp tên hoặc mã sản phẩm của Thuốc Vantive. Cung cấp tên của tất cả các loại thuốc Vantive đang được sử dụng tại thời điểm xảy ra sự cố được báo cáo";
translations[SELECT_THE_COMPONENT] = "Chọn bộ phận gặp sự cố";
translations[USE_THE_DIAGRAM] = "Sử dụng biểu đồ trên (Hình 1) để quyết định vị trí của phụ kiện bị hư hỏng";
translations[TYPE_OF_DAMAGE] = "Vui lòng mô tả loại hư hỏng";
translations[PLEASE_ENTER_VALUE] = "Vui lòng nhập giá trị";
translations[WAS_THE_PRODUCT_KINKED] = "Sản phẩm có bị gập, nứt, bẻ cong, cắt, vv?";
translations[WERE_ANY_CLEANING] = "Sản phẩm có tiếp xúc với dung dịch vệ sinh, dung môi hay chất sát trùng nào không?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Tên hoạt chất/tên sản phẩm sát trùng và sản phẩm được sử dụng như thế nào?";
translations[NOTE_VANTIVE_LABELING] = "Nhãn sản phẩm của Vantive chỉ rõ không sử dụng chất tẩy, oxy già, cồn hoặc chất sát trùng chứa cồn nào cho bộ sản phẩm. Sử dụng các chất này có thể làm sản phẩm dễ bị nứt gãy.";
translations[SELECT_ALL_THAT_APPLY] = "Chọn tất cả phương án có áp dụng";
translations[DID_FOLLOWING_OCCUR] = "Có hiện tượng nào sau đây xảy ra không?";
translations[SELECT_THE_LOCATION] = "Chọn khu vực bị hư hỏng trên sản phẩm Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Sản phẩm có tiếp xúc với lực tác động quá mức nào (ví dụ đập mạnh, đâm, ném, vv) trước khi sự cố xảy ra không?";
translations[HOW_LONG_TRANSFER] = "Bộ chuyển tiếp đã được sử dụng bao lâu?";
translations[WAS_THERE_DIFFICULTY] = "Khi mở hoặc đóng kẹp vặn có gặp khó khăn gì không?";
translations[WAS_DEVICE_OR_TOOL] = "Bạn có sử dụng thiết bị hay công cụ nào để mở hoặc đóng kẹp vặn không?";
translations[DESCRIBE_HOW_PRODUCT] = "Mô tả sản phẩm khó sử dụng như thế nào (chọn tất cả câu trả lời có liên quan)";
translations[DID_YOU_OBSERVE] = "Bạn có quan sát thấy bất cứ hư hỏng nào (ví dụ vết cắt, lỗ, nứt) trên sản phẩm không?";
translations[WERE_DIFFICULTIES_PUTTING] = "Bạn có gặp khó khăn khi đặt Minicap vào Bộ Chuyển tiếp và vặn đến khi chắc theo chiều kim đồng hồ không?";
translations[WAS_THE_TRANSFER] = "Bạn có phải thay Bộ Chuyển tiếp vì sự cố này không?";
translations[SELECT_TYPE_OF_FLOW] = "Chọn loại vấn đề về dòng chảy";
translations[WAS_ANYTHING_BLOCKING] = "Có bất cứ thứ gì chặn dòng chảy không?";
translations[WAS_ANY_ALARM] = "Có báo động nào không?";
translations[SELECT_BEST_DESCRIBE] = "Chọn phương án mô tả sự cố đúng nhất";
translations[WERE_THE_MINICAPS] = "Minicap có bị tiếp xúc hoặc bảo quản trong môi trường nóng/lạnh không?";
translations[WAS_THE_SPONGE_VISIBLE] = "Bọt có thấy được trong Minicap không?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Tạp chất / vật thể lạ ở vị trí nào?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Mô tả chính xác vị trí, kích thước, hình dạng, và màu sắc của tạp chất / vật thể lạ:";
translations[WAS_THE_PARTICULATE_MATTER] = "Tạp chất / vật thể lạ có ở sâu bên trong sản phẩm không?";
translations[DOES_THE_PARTICULATE_MATER] = "Tạp chất / vật thể lạ có giống như là một phần của vật liệu tạo ra sản phẩm không?";
translations[WHAT_COMPONENT_DOES] = "Tạp chất xuất hiện ở bộ phận nào?";
translations[SELECT_CONNECTION_ISSUE] = "Chọn phương án mô tả sự cố về kết nối đúng nhất";
translations[WERE_ASSIST_DEVICES] = "Bạn có sử dụng thiết bị hay công cụ hỗ trợ nào để kết nối một lần không?";
translations[WERE_ANY_DIFFICULTIES] = "Bạn có gặp khó khăn nào khi bắt đầu kết nối hoặc ngắt kết nối không?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Cung cấp thông tin sản phẩm của sản phẩm thứ hai có liên quan đến sự cố kết nối";
translations[WERE_THE_SPIKE_LUER] = "Mũi nhọn/phần kết nối luer có được xoay theo chiều kim đồng hồ cho đến khi chắc hoàn toàn không?";
translations[VANTIVE_LABELING_STATES] = "Nhãn sản phẩm của Vantive chỉ rõ luôn đảm bảo tất cả kết nối của bộ phụ kiện được vặn chắc và vừa vặn trước khi tiến hành trị liệu";
translations[WERE_PETS_OR_ANIMALS] = "Có loài vật nào có thể làm hỏng bộ thiết bị dùng một lần không?";
translations[VANTIVE_LABELING_CONTAMINATION] = "Nhãn sản phẩm của Vantive chỉ rõ sự nhiễm bẩn đường đi của dịch có thể xảy ra nếu thú cưng hoặc loài vật cắn phụ kiện. Để giảm thiểu nguy cơ này, vui lòng không ở chung phòng với thú cưng hoặc loài vật trong khi lọc máu";
translations[WERE_OTHER_ISSUES] = "Có vấn đề hay khó khăn gì khác liên quan đến mũi nhọn/luer (ví dụ nứt, biến dạng, bẻ cong vv) không?";
translations[WAS_MINICAP_TWISTED] = "Minicap có được vặn theo chiều kim đồng hồ vào bộ kết nối chuyển tiếp cho đến khi chắc hoàn toàn không?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Có khó khăn gì khi đặt Minicap lên Bộ chuyển tiếp không?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Bộ kết nối chuyển tiếp có dấu hiệu hư hỏng hay chất tồn dư nào trên thân không?";
translations[WHAT_WAS_THE_ALARM] = "Báo động là gì?";
translations[WHERE_OBSERVED_DAMAGE] = "Hư hỏng xuất hiện ở vị trí nào (chọn tất cả có liên quan)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Chọn loại hư hỏng (chọn tất cả có liên quan):";
translations[DID_DAMAGE_CAUSE_LEAK] = "Hư hỏng có gây ra rò rỉ không?";
translations[WAS_THE_SHIPPING_CARTON] = "Thùng carton để vận chuyển sản phẩm có bị mở bằng một vật sắc nhọn không?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Chọn loại vấn đề về dòng chảy bạn gặp phải";
translations[HOW_LONG_WAS_STORAGE] = "Sản phẩm đã được bảo quản bao lâu trước khi được phát hiện là hết hạn?";
translations[WAS_THERE_AN_ADAPTER] = "Một bộ nguồn hoặc bất cứ thiết bị nào khác có được sử dụng cùng với sản phẩm không?";
translations[NAME_AND_MODEL] = "Tên và kiểu của bộ nguồn hoặc thiết bị khác đã được sử dụng?";
translations[NAME_VAPORIZER] = "Tên và kiểu của bình bốc hơi?";
translations[WAS_VIAL_INVERTED] = "Ống thuốc đính kèm có được đảo ngược trước khi đổ dung dịch vào ống thuốc không?";
translations[WHAT_VIAL_USED] = "Thông tin sản phẩm của ống thuốc đã sử dụng?";
translations[DRUG_NAME_MANUFACTURER] = "Tên sản phẩm, nhà sản xuất, kích cỡ chai";
translations[WERE_BREAK_FRANGIBLE] = "Khi dùng lực di chuyển ra trước và sau, khóa bảo vệ có được bẻ dễ dàng và đúng cách không?";
translations[WAS_ALARM_ASSOCIATED] = "Có cảnh báo nào xảy ra cùng với việc không có dòng chảy không?";
translations[WHAT_PART_DISCOLORED] = "Phần nào của sản phẩm bị đổi màu? (chọn tất cả có liên quan)";
translations[DESCRIBE_DISCOLORATION] = "Mô tả sự đổi màu (mô tả màu sắc, sắc độ, độ đậm nhạt, vv):";
translations[HOW_PRODUCT_STORED] = "Sản phẩm được bảo quản như thế nào?";
translations[DOES_DISCOLORATION_APPEAR] = "Sự đổi màu có vẻ mờ, đục, và/hoặc có vòng tròn/dấu hình tổ ong không?";
translations[WHICH_CHAMBER_DISCOLORED] = "Ngăn nào của túi bị đổi màu?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "Vách ngăn tạm thời đã bị hư tổn/kích hoạt chưa?";
translations[WAS_DISCOLORATION_NOTICED] = "Sự đổi màu có thể nhận biết được qua kính của bình bốc hơi không?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Chọn phương án mô tả cụ thể sự cố";
translations[WHAT_DEVICE_HAD_ALARM] = "Thiết bị nào đã phát cảnh báo?";
translations[WHAT_MISSING_MISASSEMBLED] = "Bộ phận nào bị thiếu hoặc lắp đặt sai?";
translations[RECONSTITUTION_ISSUE] = "Vui lòng mô tả cụ thể hơn về sự cố hoàn nguyên";
translations[WHAT_MEDICATION_SOLUTION] = "Thuốc/dung dịch nào đã được sử dụng để hoàn nguyên cùng với sản phẩm?";
translations[WHAT_VOLUME_MEDICATION] = "Lượng thuốc/dung dịch đã sử dụng để hoàn nguyên?";
translations[WHAT_DEVICES_RECONSTITUTION] = "(Các) thiết bị nào khác đã được sử dụng khi hoàn nguyên (tên/nhà sản xuất, kích cỡ kim/vật nhọn, vv)?";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Sản phẩm có bị tiếp xúc với nhiệt không?";
translations[DESCRIBE_EXPOSURE] = "Mô tả mức độ tiếp xúc (nhiệt độ, thời gian, vv)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Kỹ thuật nào đã được sử dụng để hoạt hóa dung dịch?";
translations[WAS_DAMAGE_OBSERVED] = "Trước khi hoạt hóa, bạn có quan sát thấy bất cứ dấu hiệu hư hỏng nào không?";
translations[DESCRIBE_THE_DAMAGE] = "Mô tả dấu hiệu hư hỏng:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Mức dung dịch hoặc bột bị thiếu hay thừa xấp xỉ bao nhiêu?";
translations[WAS_LEAK_OBSERVED] = "Có xuất hiện rò rỉ không?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Bộ phận hay tính năng nào của sản phẩm bị khó sử dụng?";
translations[HOW_WAS_DIFFICULT_USE] = "Sản phẩm bị khó sử dụng như thế nào?";
translations[WHERE_MATTER_FOREIGN] = "Tạp chất/vật thể lạ nằm ở đâu?";
translations[DOES_PARTICULATE_MATTER] = "Tạp chất/vật thể lạ có phải là một phần của vật liệu tạo nên sản phẩm không?";
translations[DESCRIBE_EXACT_LOCATION] = "Xin mô tả chính xác vị trí, màu sắc, kích thước, hình dạng, và kết cấu của tạp chất/vật thể lạ";
translations[WAS_MATTER_FOREIGN] = "Tạp chất/vật thể lạ có gắn cố định vào sản phẩm không (không di chuyển tự do)?";
translations[WHEN_MATTER_FOREIGN] = "Tạp chất/vật thể lạ được phát hiện lúc nào?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Xin cung cấp thông tin về thuốc đã thêm vào:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Tên sản phẩm, mã số sản phẩm, số lô, tên biệt dược";
translations[DESCRIBE_SPIKING] = "Xin mô tả kỹ thuật đâm hoặc hoàn nguyên đã sử dụng:";
translations[INCLUDE_NEEDLE] = "Thêm kích cỡ của kim, góc đâm, số lần thử ";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Thiết bị hoàn nguyên hoặc thiết bị quản lý nào đã được sử dụng?";
translations[INCLUDE_MANUFACTURER] = "Thêm nhà sản xuất, tên sản phẩm, mã số sản phẩm, số lô";
translations[WAS_MEDICATION_ADDITIVE] = "Có thuốc, chất bổ sung, hoặc dung dịch hoàn nguyên nào được thêm vào không?";
translations[WHAT_MEDICATION_ADDITIVE] = "Thuốc, chất bổ sung, hoặc dung dịch nào đã được thêm vào?";
translations[WHAT_STATE_OF_PRODUCT] = "Trạng thái của sản phẩm như thế nào khi có hiện tượng đục/kết tủa?";
translations[AFTER_UNITS_SAT] = "Sau khi sản phẩm được để yên và đạt nhiệt độ phòng, hiện tượng đục/kết tủa có chấm dứt không?";
translations[DID_ATTEMPT_AGITATE] = "Bạn có thử khuấy sản phẩm không?";
translations[DID_PRECIPITATE_DISSOLVE] = "Kết tủa có tan không?";
translations[WHAT_STORAGE_TEMPERATURE] = "Điều kiện và nhiệt độ bảo quản sản phẩm?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Cung cấp nhiệt độ, vị trí, bảo quản bên trong hay ngoài túi bảo vệ/thùng, ở trong VSC/thùng trung gian, đơn vị lẻ";
translations[ARE_TEMPERATURE_LOGS] = "Ghi chép nhiệt độ của tủ đông bảo quản sản phẩm có sẵn không?";
translations[LOGS_CAN_BE_ATTACHED] = "Nhật ký có thể được đính kèm trực tiếp với biểu mẫu này, nếu sẵn có tại thời điểm gửi ";
translations[IS_THE_STORAGE_UNIT] = "Thiết bị bảo quản (tủ đông hoặc tủ lạnh) có được thẩm định và kiểm soát nhiệt độ không?";
translations[HOW_PRODUCT_THAWED] = "Sản phẩm được rã đông như thế nào?";
translations[WHAT_STORAGE_CONDITIONS] = "Điều kiện bảo quản sản phẩm? (nhiệt độ, vị trí, bảo quản trong hay ngoài túi bảo vệ/thùng carton?)";
translations[WAS_ANY_DAMAGE] = "Có hư hỏng hay sự cố nào được nhận thấy trên sản phẩm không?";
translations[MORE_SPECIFIC_INFORMATION] = "Xin cung cấp thêm thông tin cụ thể:";
translations[WHAT_PURPOSE_INDICATION] = "Mục đích/chỉ định của trị liệu cho bệnh nhân?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Đường dùng?";
translations[WHAT_DATE_ADMINISTRATION] = "Ngày sử dụng và thời gian sử dụng?";
translations[WHAT_DOSAGE_STRENGTH] = "Liều dùng/nồng độ/hàm lượng đã sử dụng cho bệnh nhân?";
translations[WAS_RECENT_PRESCRIPTION] = "Có thay đổi về kê đơn gần đây nào không?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Chi tiết điều kiện bảo quản/nhiệt độ của sản phẩm (nơi bảo quản/tủ lạnh/tủ đông, vv)?";
translations[WERE_ANY_ADJUSTMENTS] = "Có sự điều chỉnh nào với dung dịch hoặc thêm chất nào trước khi sử dụng không?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Chọn mô tả phù hợp nhất với sự cố:";
translations[SELECT_LABELING_ISSUE] = "Chọn mô tả phù hợp nhất với sự cố về nhãn:";
translations[WAS_CONNECTION_SECURE] = "Chỗ kết nối có được vặn chắc không?";
translations[WAS_EXPIRED_PRODUCT] = "Sản phẩm hết hạn có được sử dụng cho bệnh nhân không?";
translations[WAS_COMPONENT_DAMAGED] = "Có bộ phận nào bị hư hỏng không?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Có hư hỏng/bất thường nào trên sản phẩm không?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Mã số đơn đặt hàng của bạn?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Ngày sử dụng?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Ngày hết hạn của sản phẩm?";
translations[DESCRIBE_WAS_INCORRECT] = "Xin mô tả phần bị sai, không hoàn chỉnh, không rõ ràng trên nhãn hoặc phần quá giống với một sản phẩm khác trên nhãn:";
translations[WHAT_SCANNER_USED] = "Loại máy quét đã được sử dụng?";
translations[WAS_OVERPOUCH_POUCH] = "Sản phẩm có còn nguyên trong túi bảo vệ khi quét không?";
translations[WHAT_BACKGROUND_COLOR] = "Màu của nền khi quét?";
translations[DO_ALL_OF_THE_LABELS] = "Tất cả các nhãn (sản phẩm, hộp/thùng, vận chuyển/phân phối) có thông tin sản phẩm giống nhau không?";
translations[PRODUCT_INFORMATION] = "Thông tin sản phẩm";
translations[IS_A_BARCODE_SCANNER] = "Cơ sở của bạn có sử dụng máy quét mã vạch không?";
translations[HOW_ARE_THESE_PRODUCTS] = "Những sản phẩm này được bảo quản ở cơ sở của bạn như thế nào?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Thông tin nào đã thể hiện không đúng khi quét?";
translations[WAS_THERE_LEAK] = "Có dấu hiệu rò rỉ hay ẩm nào không?";
translations[WHERE_LEAK_OBSERVED] = "Vị trí phát hiện rò rỉ, bộ phận bị rò rỉ?";
translations[WAS_FRANGIBLE_OBSERVED] = "Vách ngăn có bị vỡ không?";
translations[IS_MOISTURE_CLEAR] = "Hơi ẩm có nhìn rõ không?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Nhà phân phối của bạn là ai?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Nhà sản xuất, tên thuốc, kích cỡ của chai đã sử dụng?";
translations[WHAT_GAUGE_NEEDLE] = "Kích thước kim đã sử dụng, nhà sản xuất, số lần đâm?";
translations[WHAT_ADMINISTRATION_SET] = "Thiết bị quản lý đã sử dụng?";
translations[WAS_DIFFICULTY_SPIKING] = "Khi đâm có gặp khó khăn gì không?";
translations[WERE_FOLLOWING_SCENARIOS] = "Có một trong những trường hợp sau đây xảy ra cùng với việc rò rỉ không?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Vách ngăn có bị hư hỏng hay bể vỡ không?";
translations[WHAT_AMOUNT_PRESSURE] = "Áp lực đã sử dụng và trong bao lâu?";
translations[WAS_BAG_COMPLETELY] = "Túi có được đưa hoàn toàn và đúng cách vào cổ áp lực không (một đầu nằm ngoài cổ)?";
translations[WHAT_MANUFACTURER_MODEL] = "Nhà sản xuất, mẫu và kích thước của cổ áp lực?";
translations[WHAT_PRESSURE_PRIOR] = "Áp lực trước khi phát hiện rò rỉ là bao nhiêu?";
translations[LIST_THE_VAPORIZER] = "Danh sách nhà sản xuất bình bốc hơi và tên/mẫu?";
translations[APPROXIMATELY_HOW_MUCH] = "Khoảng bao nhiêu chất lỏng đã bị đổ?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "Có khó khăn khi gắn chai vào bình bốc hơi không?";
translations[WERE_VISIBLE_DEFECTS] = "Có hư hỏng nhìn thấy được nào không?";
translations[SELECT_THE_OPTION] = "Chọn phương án mô tả sự cố về kết nối đúng nhất";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Cung cấp thông tin sản phẩm của sản phẩm thứ hai có liên quan đến sự cố kết nối";
translations[WHICH_PART_SEPARATED] = "Phần nào của sản phẩm bị rời ra?";
translations[WHAT_COMPONENT_DISCOLORED] = "Bộ phận nào bị đổi màu?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Chọn phương án mô tả sự đổi màu đúng nhất:";
translations[WAS_THE_SET_DISCOLORED] = "Khi lấy ra khỏi bao bì, bộ sản phẩm có bị đổi màu không?";
translations[DID_SET_CHANGE_COLOR] = "Bộ sản phẩm có đổi màu sau khi thêm thuốc không?";
translations[WHAT_MEDICATION_ADDED] = "Thuốc nào đã được thêm vào trước khi đổi màu?";
translations[WHERE_MATERIAL_LOCATED] = "Tạp chất/vật thể lạ được phát hiện ở đâu?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Mô tả tạp chất/vật thể lạ (hình thức/màu sắc/kích thước):";
translations[WAS_EMBEDDED_PLASTIC] = "Tạp chất/vật thể lạ ở ngoài hay gắn vào chất dẻo?";
translations[WAS_THERE_A_PRECIPITATE] = "Có kết tủa hoặc đổi màu không mong muốn nào xảy ra trong dịch truyền/dung dịch không?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Thuốc/dung dịch nào đã được truyền vào qua bộ sản phẩm?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Vị trí hư hỏng hoặc bộ phận bị ảnh hưởng (chọn tất cả phương án có liên quan)?";
translations[WHAT_DAMAGE_ISSUE] = "Loại hư hỏng/vấn đề được nhận thấy (chọn tất cả các phương án có liên quan)?";
translations[DID_ISSUE_RESULT] = "Sự cố có gây ra rò rỉ không?";
translations[WAS_PATIENT_CONNECTED] = "Có bệnh nhân nào có liên quan đến sản phẩm không?";
translations[WAS_PRODUCT_REPLACED] = "Sản phẩm có được thay thế bằng một sản phẩm mới không?";
translations[WHICH_SITUATION_BEST] = "Tình huống nào mô tả đúng nhất sự cố tách rời/kết nối?";
translations[SELECT_MOST_LABELING_ISSUE] = "Chọn mô tả phù hợp nhất với sự cố về nhãn:";
translations[WHAT_INFORMATION_DISPLAYED] = "Thông tin nào được thể hiện?";
translations[WHAT_SCANNER_WAS_USED] = "Loại máy quét đã được sử dụng?";
translations[INCLUDE_THE_MODEL_NAME] = "Thêm tên model";
translations[WAS_PRODUCT_ORDERED] = "Sản phẩm được đặt hàng trực tiếp từ Vantive hay từ nhà phân phối khác?";
translations[WHERE_LEAK_COMING] = "Vị trí rò rỉ (chọn tất cả các phương án áp dụng)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Tình huống nào sau đây đã xảy ra cùng với hiện tượng rò rỉ?";
translations[WAS_POWER_INJECTOR] = "Sản phẩm có được sử dụng chung với một bơm kim điện không?";
translations[WHAT_INJECTOR_USED] = "Loại bơm kim điện nào đã được sử dụng?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Nhà sản xuất, tên sản phẩm, mã số sản phẩm, số lô";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Mô tả phần không chính xác, không toàn vẹn, bị thiếu, không rõ, hoặc thay đổi trên nhãn:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Cung cấp thông tin sản phẩm của sản phẩm thứ hai có liên quan đến sự mất kết nối";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Bộ phận nào được tìm thấy bị nứt hoặc gãy?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Mô tả vị trí chính xác trên ống có vết cắt, lỗ, hoặc lát cắt:";
translations[WAS_LEAK_ORIGINATING] = "Rò rỉ có bắt nguồn từ vùng tiêm không?";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Cung cấp thông tin của sản phẩm thứ hai liên quan đến sự cố ngắt kết nối/kết nối";
translations[WHICH_SPECIFIC_BONDED] = "Bộ phận dính liền nào đã bị tách rời?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Sản phẩm/bộ phận có liên quan có dấu hiệu bất thường/hư hỏng dễ nhận thấy nào không?";
translations[WAS_SUCCESSFUL_CONNECTION] = "Cuối cùng sự kết nối/ngắt kết nối có thành công không (mà không phải thay thế sản phẩm)?";
translations[WAS_TOOL_USED_ASSIST] = "Bạn có cần phải sử dụng một dụng cụ nào để hỗ trợ việc kết nối/ngắt kết nối không?";
translations[WERE_LUER_CONNECTIONS] = "Tất cả kết nối luer có được kiểm tra (theo hướng dẫn trên nhãn sản phẩm) để đảm bảo chúng chắc chắn trước khi sử dụng không?";
translations[WAS_PRODUCT_SECURELY] = "Sản phẩm có được kết nối chắc chắn với một sản phẩm khác trước khi ngắt kết nối không?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Trường hợp nào mô tả sự cố dòng chảy đúng nhất?";
translations[WHAT_FLOWING_BACKWARDS] = "Cái gì bị chảy ngược lại?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Mô tả bộ phận bắt đầu và kết thúc của dòng chảy ngược";
translations[DO_SITUATIONS_APPLY] = "Có bất cứ tình huống nào dưới đây đúng với sự cố không?";
translations[WHICH_SPECIFIC_AREA] = "Vị trí cụ thể nào của bộ sản phẩm hoặc bộ phận có liên quan đến sự cố dòng chảy?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Trước đó dòng chảy có được thấy qua bộ sản phẩm hoặc bộ phận không?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Tình huống nào sau đây đã quan sát được:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Dòng chảy mô phỏng ở giữa vị trí nào?";
translations[WHAT_TYPE_HANGER] = "Loại móc treo nào đã được sử dụng?";
translations[WHAT_WAS_HANGER_LENGTH] = "Chiều dài và/hoặc nhà sản xuất của móc treo?";
translations[WHICH_BAG_LOWER] = "Túi nào ở thấp hơn?";
translations[WHAT_Y_SITE_WAS] = "Bộ thứ hai đã kết nối với vùng chữ y nào?";
translations[WHAT_COMPONENT_WITHIN] = "Bộ phận nào của bộ sản phẩm không thể làm sạch khỏi dung dịch hoặc máu?";
translations[WAS_COMPONENT_SET_REPLACED] = "Bộ phận/bộ sản phẩm có được thay thế sau khi không thể làm sạch được không?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Thế tích chất lỏng cần được truyền cho bệnh nhân và khoảng thời gian chỉ định?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Thể tích chất lỏng thực tế đã được truyền cho bệnh nhân và khoảng thời gian?";
translations[WAS_USED_WITH_PUMP] = "Bộ sản phẩm có được sử dụng cùng với bơm không?";
translations[DID_CLAMP_FAIL] = "Có một cái kẹp nào đã không dừng hoặc không kiểm soát được dòng chảy không?";
translations[WHAT_CLAMP_FAILED] = "Đó là cái kẹp nào?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Có sự cố gì xảy ra với cái kẹp không?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Có bất cứ trường hợp nào dưới đây mô tả sự cố của sản phẩm không (chọn tất cả áp dụng được)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Mô tả báo động đã quan sát được:";
translations[INCLUDE_ANY_MESSAGES] = "Thêm nội dung và mã lỗi đi kèm với cảnh báo";
translations[WHICH_CLAMP_HAD_ISSUE] = "Cái kẹp nào gặp sự cố?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Loại sự cố nào đã xảy ra với cái kẹp (chọn tất cả các phương án áp dụng)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Chọn phương án mô tả chính xác nhất sự cố:";
translations[PROVIDE_MORE_DETAILS] = "Cung cấp thêm chi tiết sản phẩm đã khó sử dụng như thế nào:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Cung cấp thêm chi tiết phần hướng dẫn nào khó thực hiện/khó hiểu:";
translations[DESCRIBE_THE_SMELL] = "Mô tả mùi và vị trí có mùi:";
translations[WAS_ISSUES_WITH_SET] = "Có bất cứ sự cố nào được phát hiện trên bộ sản phẩm không?";
translations[WHERE_LEAK_LOCATED] = "Vị trí rò rỉ ở đâu trên sản phẩm?";
translations[DID_OCCUR_WITH_LEAK] = "Có bất cứ hiện tượng nào dưới đây xảy ra cùng với việc rò rỉ không?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Cung cấp thông tin sản phẩm của sản phẩm thứ hai có liên quan đến sự mất kết nối";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Tình huống nào sau đây đã xảy ra cùng với hiện tượng rò rỉ?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Vị trí sản phẩm bị hư hỏng?";
translations[SELECT_ALL_APPLY] = "Chọn tất cả phương án có áp dụng";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Mô tả hư hỏng";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Bộ phận nào của sản phẩm bị đổi màu?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Mô tả màu sắc bạn thấy (màu sắc, sắc độ, đậm nhạt, vv)";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Ở trong hay ngoài túi bảo vệ, nhiệt độ, tiếp xúc với ánh sáng, vv";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Mô tả chính xác vị trí, kích thước, hình dạng, và màu sắc của tạp chất / vật thể lạ:";
translations[DOES_THE_PARTICULATE_MATTER] = "Tạp chất/vật thể lạ có phải là một phần của vật liệu tạo nên sản phẩm không?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Tạp chất/vật thể lạ có gắn cố định không?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Tạp chất / vật thể lạ có giống như là một phần của vật liệu tạo ra sản phẩm không?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Sự cố xảy ra trên vị trí nào của sản phẩm";
translations[LIST_COMPONENTS_IF] = "Liệt kê các bộ phận. Nếu có sản phẩm thứ hai có liên quan, cung cấp nhà sản xuất, tên sản phẩm, mã số sản phẩm, số lô";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Có bất thường/hư hỏng nào nhìn thấy được không?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Chọn phương án đúng nhất mô tả sự cố về dòng chảy";
translations[DESCRIBE_IRREGULARITIES] = "Mô tả bất thường, hư hỏng, hư hỏng quan sát được trước khi kết nối/ngắt kết nối, hay trong quá trình kết nối/ngắt kết nối";
translations[HOW_PRODUCT_SETUP] = "Sản phẩm được cài đặt như thế nào?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Chọn mô tả phù hợp nhất với sự cố về nhãn:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Xin mô tả phần bị sai, không hoàn chỉnh, không rõ ràng trên nhãn hoặc phần quá giống với một sản phẩm khác trên nhãn:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Sản phẩm ở bên trong thùng vận chuyển có bị hư không?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Sản phẩm nào đáng lẽ sẽ được nhận?";
translations[IF_PRODUCT_CODE_NOT] = "Nếu không có mã sản phẩm, xin mô tả sản phẩm";
translations[WAS_THE_CASE_MISSING] = "Trường hợp xảy ra có phải là thiếu đá khô hoặc gel lạnh không?";
translations[WHAT_CARRIER_DELIVERED] = "Nhà vận chuyển nào đã giao hàng của bạn?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Mã số đơn đặt hàng của bạn?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Số lượng đơn vị bị thiếu?";
translations[WAS_EXPIRED_PRODUCT_USE] = "Sản phẩm hết hạn đã được sử dụng chưa?";
translations[APPLY_TO_EACH_UNIT] = "Nếu vấn đề xảy ra trên nhiều đơn vị, những câu hỏi dưới đây áp dụng cho mỗi đơn vị";
translations[TERMS_CONDITIONS] = "Điều khoản & Điều kiện";
translations[PRIVACY_POLICY] = "Chính sách bảo mật";
translations[PRIVACY_NOTICE] = "Thông báo về quyền riêng tư";
translations[COOKIE_POLICY] = "Chính sách cookie";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Đã hỏi nhưng Không biết";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Nhân viên Vantive";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Nhân viên chăm sóc sức khỏe";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Nhà phân phối";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Chuyên gia y tế";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Bệnh nhân";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Khác";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Sau khi sử dụng";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Trước khi sử dụng";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Trong khi thiết lập/chuẩn bị/pha trộn";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Trong khi trị liệu";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Nhiều giai đoạn";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Không xác định";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Thành viên gia đình";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Điều dưỡng";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Điều dưỡng chuyên biệt";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Nhân viên y tế khác";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Bác sĩ";
translations[OPTION_UNITOPTIONS_BOXES] = "Hộp";
translations[OPTION_UNITOPTIONS_PALLETS] = "Pallet";
translations[OPTION_UNITOPTIONS_UNITS] = "Đơn vị";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Tình trạng báo động";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Hư hỏng";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Khó sử dụng";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Đổi màu";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Vấn đề về dòng chảy";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Vấn đề về nhãn";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Rò rỉ / Quá nhiều hơi ẩm";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Tạp chất / vật thể lạ";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Phản ứng của bệnh nhân / Biến cố bất lợi";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Thắc mắc về sản phẩm";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Phân ly / Kết nối";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Vấn đề về vận chuyển / Sản phẩm hết hạn";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Nữ";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Không phân biệt";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Nam";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Từ chối trả lời";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Người quản trị/Người giám sát";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Kỹ sư y sinh";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Đại diện công ty";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Nha sĩ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Nhà phân phối";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Thành viên gia đình";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Người dùng phổ thông";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Điều dưỡng";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Điều dưỡng chuyên biệt";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Nhân viên y tế khác";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Dược sĩ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Kỹ thuật viên dược";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Bác sĩ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Bệnh nhân";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Quản lý nguy cơ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Khác";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Liên lạc người bổ sung";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Liên lạc tôi";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Liên lạc người khác";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japan)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australia)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Vật nuôi hoặc thú có thể đã gây ra sự cố";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Một công cụ hoặc vật sắc đã được sử dụng để mở thùng hoặc túi bảo vệ";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Sản phẩm đã chịu lực mạnh (va, đập, ném, vv) trước khi xảy ra sự cố";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Sản phẩm đã tiếp xúc/được bảo quản ở môi trường quá nóng/quá lạnh";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Thùng";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Nắp nhỏ";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Túi";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Bộ chuyển tiếp quá chặt";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Bộ chuyển tiếp quá lỏng";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "Bộ chuyển tiếp không thể đóng hoàn toàn được";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "Bộ chuyển tiếp không thể mở hoàn toàn được";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "Nắp vặn quá chặt nên bộ chuyển tiếp không thể mở được";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "Nắp vặn quá chặt nên bộ chuyển tiếp không thể đóng được";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Đúng - có hư hỏng/điều không đúng xảy ra với bộ chuyển tiếp làm cho nó không thể đóng đúng cách được";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Đúng - nắp nhỏ đã bị vặn quá mức vào bộ chuyển tiếp bằng tay hoặc bằng công cụ/thiết bị hỗ trợ";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Hoàn toàn dừng mà không có dòng chảy của dịch";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Hạn chế hoặc chỉ chảy một phần (chảy chậm)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Máu đông";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Sợi huyết";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Gấp khúc";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Vật thể lạ";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Vật liệu của sản phẩm";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Iod dư (màu nâu) được phát hiện khi kết nối hoặc trong bao bì";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Hơi nước dư (giọt trong suốt) được phát hiện trong bao bì";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Bao giấy bạc bị hư hỏng trước khi mở";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Bao bì/hộp bị mở hoặc hư hỏng trước khi sử dụng";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Miếng bọt biển bị khô và có màu trắng";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Miếng bọt biển bị khô và có màu nâu";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "Trong bao bì thứ cấp/túi bảo vệ";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Bên trong sản phẩm/trên đường đi của dịch";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Trong thùng vận chuyển";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Bên ngoài sản phẩm";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "Trên mặt ngoài của bao bì thứ cấp/túi bảo vệ";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Trên mặt ngoài của thùng vận chuyển";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Khó kết nối sản phẩm với một sản phẩm khác";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Khó ngắt kết nối sản phẩm khỏi một sản phẩm khác";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Một thành phần bị tách ra khỏi một sản phẩm đơn lẻ";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Sự tách ra/ngắt kết nối của một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "Có - phần còn lại ở trên chủ đề";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "CÓ - hư tổn nhìn thấy được";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Đúng - khác (điền vào đây)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Khóa bẻ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Lỗ để treo";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Cổng làm đầy/tiêm";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Cổng màng";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Túi bảo vệ/túi";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Miếng";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Cái chặn bằng cao su";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Thùng vận chuyển";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Dây co rút";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Vật chứa dung dịch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Miếng bảo vệ đầu nhọn";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Tem chống giả mạo (màng co)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Bị bẻ cong";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Vỡ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Nứt";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Đứt";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Biến dạng";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Tróc ra";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Có lỗ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Gấp khúc";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Chảy";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Các lớp bị tách rời";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Bị trầy (kính)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Cắt";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Rách";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "Dung dịch không chảy được";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "Dung dịch chảy rất chậm";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "Dung dịch không chảy (hoặc chảy chậm) trong khi hoàn nguyên hoặc pha chế";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Chai";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Vật chứa";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Lỗ treo";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Lót";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Túi bảo vệ/túi";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Chỉ thị Oxy";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Miếng";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Cổng";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Dung dịch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Vật bảo vệ đầu nhọn";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Ngăn amino axít";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Ngăn Dextrose";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Ngăn Lipid";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Ngăn dưới";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Ngăn trên";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Rách/gián đoạn niêm phong";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Sản phẩm/bộ phận bị lắp đặt sai";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Thiếu bộ phận";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Bộ phận dính liền bị rời ra/ngắt kết nối";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Sản phẩm bị đầy quá";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "sản phẩm bị thiếu";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Vấn đề về hoàn nguyên";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "Trong bao bì thứ cấp/túi bảo vệ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Trong thùng vận chuyển";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "Trên bề mặt ngoài của thùng vận chuyển";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Bên trong đường dẫn dung dịch/chất lỏng";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Trong hầm chứa của bình bốc hơi (cửa sổ kính)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Trên bề mặt ngoài sản phẩm";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "Trên mặt ngoài của bao bì thứ cấp/túi bảo vệ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Trên miếng hấp phụ Oxy";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Trên miếng xuyên qua da";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Khóa bẻ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Mảnh kính";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Cổng";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Miếng chặn cao su";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Ống";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Sau khi thêm một thuốc khác hoặc sau khi hoàn nguyên (lọ)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Trước khi đâm hoặc hoàn nguyên";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Lạnh (đã rã đông nhưng chưa đạt nhiệt độ phòng)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Đông đá";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Rã đông một phần (có tinh thể nước đá trong dung dịch)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Nhiệt độ phòng";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Đơn vị rã đông Vantive (VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Bỏ trên quầy ở nhiệt độ phòng";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Tủ lạnh";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Đúng - có bằng chứng hư hỏng trong khi vận chuyển";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Đúng - có dấu hiệu rò rỉ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Đúng - túi bảo vệ có lỗ hoặc niêm phong không toàn vẹn";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Đúng - khó đâm hoặc hoàn nguyên";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Đúng - khó làm gãy khóa bẻ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Đúng - có tinh thể hoặc kết tủa trong dung dịch";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Đúng - sản phẩm frozen galaxy bị gợn/tủa";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Sản phẩm không mang lại hiệu quả mong muốn hoặc không có hiệu quả (thiếu hiệu quả)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Tác dụng/phản ứng không định trước. Xin chỉ rõ (điền vào đây)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Hư hỏng thùng vận chuyển trong khi vận chuyển";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Giao sản phẩm đã hết hạn";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Tìm thấy sản phẩm đã hết hạn";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Vấn đề mã vạch - thông tin hiển thị không đúng khi quét";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Khó quét/không quét được mã vạch";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Giao sản phẩm đã hết hạn";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Tìm thấy sản phẩm đã hết hạn trong bản kiểm kê hàng hóa";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Nhãn không rõ";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Nhãn không chính xác";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Nhãn không đầy đủ";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Nhãn quá tương tự với một sản phẩm khác";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Các nhãn (sản phẩm, hộp/thùng, danh sách vận chuyển) không có cùng thông tin sản phẩm";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Thiếu mã vạch";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Thùng/hộp chứa sản phẩm sai hoặc lẫn sản phẩm khác";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Thùng vận chuyển bị hư hỏng trong khi vận chuyển";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Nhận thêm nhiều đơn vị hơn";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Giao sản phẩm hết hạn ";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Tìm thấy sản phẩm hết hạn";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Một phần của thùng bị mở hoặc không được dán kín";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Thông tin sản phẩm trên thùng và nhãn vận chuyển không khớp với sản phẩm trong thùng";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Thiếu đơn vị";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Thiếu nhãn";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Ngày hết hạn";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Số lô";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "Số NDC";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Nhỏ gọt/có hơi ẩm bên trong túi bảo vệ và không có dấu hiệu rò rỉ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Rò rỉ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Rò rỉ phát hiện khi vặn túi";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Dung dịch chảy qua khóa bẻ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Dung dịch bên trong túi bảo vệ và không có dấu hiệu rò rỉ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Giữa túi bảo vệ và bao bì sơ cấp";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Kết nối giữa hai sản phẩm";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Vật đựng - Cổng màng bao/ống";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Vật đựng - Cổng làm đầy/tiêm";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Vật đựng - lỗ treo";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Vật chứa";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Khóa bẻ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Cái chặn bằng cao su";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Vòng co";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Miếng bảo vệ đầu nhọn";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Bộ chuyển đổi gắn với lọ";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Cổng dính liền";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Hư hỏng (lỗ, rách) trên bao bì thứ cấp hoặc thùng trung gian";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Tiếp xúc với nhiệt độ quá nóng/quá lạnh";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Rò rỉ tại giao diện bình bốc hơi";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Mở thùng vận chuyển với một vật sắc nhọn";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Thú nuôi (cào/nhai)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Túi đựng dung dịch bị đè nén bằng cổ áp suất hoặc thiết bị khác";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Cổng dính liền";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Hư hỏng (lỗ, rách) trên bao bì thứ cấp hoặc thùng trung gian";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Hư hỏng trên thùng vận chuyển trong khi vận chuyển";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Tiếp xúc với nhiệt độ quá nóng/quá lạnh";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Rò rỉ tại giao diện bình bốc hơi";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Mở thùng vận chuyển với mọt vật sắc nhọn";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Thú nuôi (cào/nhai)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Túi đựng dung dịch bị đè nén bằng cổ áp suất hoặc thiết bị khác";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Không phải các trường hợp trên";
translations[NO_DESCRIBE_THE_COLOR] = "Không - mô tả màu sắc (điền vào đây)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "Lớn hơn 10ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Dưới 1ml";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Chai";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Nắp";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Van/cổ";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Không cái nào";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Khó kết nối sản phẩm với một sản phẩm khác";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Khó ngắt kết nối sản phẩm khỏi một sản phẩm khác";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Một thành phần bị tách ra khỏi một sản phẩm đơn lẻ";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Sự tách ra/ngắt kết nối của một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Ngăn bị nhỏ giọt";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Ống dẫn";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Khác - Xin chỉ rõ (điền vào đây)";
translations[OTHER_PLEASE_SPECIFY] = "Khác - Xin chỉ rõ (điền vào đây)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Trắng/đục";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Vàng/ngả nâu";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Khác - Xin chỉ rõ (điền vào đây)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "Trong bao bì sơ cấp/bao nhựa";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Bên trong đường truyền dịch (trong ống dẫn)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Trong thùng vận chuyển";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Trên bề mặt ngoài thùng vận chuyển";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Bên ngoài đường truyền dịch (bên ngoài ống dẫn)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Dính vào";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Lỏng lẻo";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Không liên quan";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Mô tả màu (điền vào đây)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Đúng - Đổi màu";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Đúng - Kết tủa";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Vùng tiếp xúc";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "bu-rét";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Nắp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Ngăn rò rỉ";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Ống dẫn";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Không biết";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Bộ lọc";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Cổng kết nối";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Đầu nhọn";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Bộ phận bị cắt/nứt/bể";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Bộ phận bị lắp ráp không chính xác - Điền mô tả vào đây";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Bộ phận bị gấp khúc/bẹp";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Bộ phận bị lỏng bên trong bao bì";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Bộ phận bị biến dạng";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Thiếu bộ phận";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Khó kết nối một sản phẩm với một sản phẩm khác";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Khó ngắt kết nối một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Kết nối lỏng lẻo";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Tách rời/ngắt kết nối một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Tách rời giữa hai bộ phận nối với nhau trên cùng một sản phâm";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "Không kết nối được hai sản phẩm với nhau";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Không thể ngắt kết nối một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Vấn đề mã vạch - thông tin hiển thị không đúng khi quét";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Thay đổi trên nhãn";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Khó quét/không quét được mã vạch";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Sản phẩm hết hạn";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Thông tin trên nhãn không chính xác";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Thiếu mã vạch/UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Thiếu thông tin trên nhãn";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Sản phẩm không có hạn sử dụng";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Nhãn bị ố/không rõ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Thùng/hộp chứa sản phẩm sai hoặc lẫn lộn sản phẩm";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Thùng vận chuyển bị hư hỏng khi vận chuyển";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Giao sản phẩm hết hạn ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Tìm thấy sản phẩm hết hạn";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "Nhà phân phối";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Nhận thêm nhiều đơn vị hơn";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Một phần của thùng bị mở ra hoặc không được dán lại";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Thông tin sản phẩm trên thùng và nhãn vận chuyển không trùng khớp với sản phẩm bên trong thùng";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Thiếu đơn vị";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Khu vực tiếp xúc";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Thông khí";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Bu rét";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Nắp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Vùng tiêm trong suốt";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Nắp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Ngăn nhỏ giọt";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Lọc";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Vùng tiêm kết nối bên trong";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Cổng kết nối";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Mũi nhọn";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Ống";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Rò rỉ giữa vùng tiêm và ống";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Vùng tiêm trên kim tiêm";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "Vùng tiêm kết nối một lần";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Vùng tiêm khác (điền vào đây)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Nứt/gãy phần cứng của bộ phận";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Đứt/cắt ống mềm";
translations[DISCONNECTION_OF_CONNECTABLE] = "Ngắt kết nối giữa các bộ phận/sản phẩm với nhau";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Ngắt kết nối giữa các bộ phận/sản phẩm với nhau";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Bộ phận kết nối với nhau bị tách rời";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Đúng - Mô tả bất thường/hư hỏng (điền vào đây)";
translations[YES_SPECIFY_THE_TOOL] = "Đúng - Mô tả thiết bị đã dùng (điền vào đây)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Chảy ngược";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Lỗi nắp - Khó đậy nắp (cuối cùng vẫn đậy được)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Lỗi nắp - Không đậy nắp hoàn toàn được";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Lỗi nắp - Khó/không mở được";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Không có dòng chảy";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Truyền quá mức";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Hạn chế/chảy chậm";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Chảy song song";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Không thể làm sạch bộ phận";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Không mồi được";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Truyền không đủ";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Máu của bệnh nhân (không phải sản phẩm máu đã truyền)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Sản phẩm dung dịch/máu";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Hư tổn rò rỉ/lỗ hổng";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Mất kết nối";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Rò rỉ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Thuốc được đưa vào qua xi ranh truyền có áp suất hoặc bơm truyền";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "Túi thứ cấp thấp hơn túi sơ cấp";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "Túi thứ cấp đặt ở độ cao bằng túi sơ cấp";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Đông máu";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Ống thông không xả được trước khi gắn với bộ sản phẩm";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Ống bị gấp";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Ống dẫn/vùng tiêm bị tắc";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Bao bì sơ cấp và thứ cấp ";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Hai hoặc nhiều hơn hai dòng chảy trong một bộ đa hướng";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Hai bộ quản lý, mỗi loại dùng riêng một bơm truyền";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Móc treo của Vantive";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "Móc treo không phải của Vantive";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Các túi được treo cùng độ cao";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Sơ cấp";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Thứ cấp";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Ở giữa";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Ở dưới";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Ở trên";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Đúng - Cung cấp tên và mã sản phẩm của bơm (điền vào đây)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Nắp trượt màu xanh đậm";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Nắp trượt màu xanh nhạt";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Nắp khía";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Nắp vặn";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Nắp trượt màu trắng";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Đúng - nắp bị gãy hoặc nứt";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Có khí trong ống dẫn";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Vấn đề về nắp";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Có mùi";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Nắp khắc/nắp bấm";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Nắp vặn";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Nắp trượt";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Bị nứt/gãy";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Khó mở";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Khó đóng";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Thiếu";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Không mở được";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Không đóng được";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Không kiểm soát dòng chảy được";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Khó vắt túi nhỏ giọt";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Hướng dẫn khó thực hiện/khó hiểu";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Sản phẩm khó sử dụng";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Nứt/gãy";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Đứt/cắt";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Ngắt kết nối giữa các bộ phận/sản phẩm với nhau";
translations[DISCONNECTION_OF_CONNECTABLE] = "Ngắt kết nối giữa các bộ phận/sản phẩm với nhau";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Lỗ/Rách";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Các bộ phận gắn liền bị tách rời";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Cổng dính liền";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Hư hỏng (lỗ, rách) trên bao bì thứ cấp hoặc thùng trung gian";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Hư hỏng trên thùng vận chuyển trong khi vận chuyển";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Tiếp xúc với nhiệt độ quá nóng/quá lạnh";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Mở thùng vận chuyển với mọt vật sắc nhọn";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Không phải các trường hợp trên";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Sử dụng cốc áp suất hoặc tiêm áp suất";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Cổng dính liền";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "thú nuôi (cào/nhai)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Sản phẩm";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Thùng vận chuyển/hộp";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Bên trong sản phẩm";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Trong thùng vận chuyển";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Trên mặt ngoài của sản phẩm";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Khó kết nối sản phẩm với một sản phẩm khác";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Khó ngắt kết nối sản phẩm khỏi một sản phẩm khác";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Kết nối lỏng lẻo";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Một thành phần bị tách ra khỏi một sản phẩm đơn lẻ";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Sự tách ra/ngắt kết nối của một sản phẩm khỏi một sản phẩm khác";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Trên mặt ngoài của thùng vận chuyển";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "Trên mặt trong của bao bì thứ cấp/túi bảo vệ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "Trên mặt ngoài của bao bì thứ cấp/túi bảo vệ";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Không chảy";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Hạn chế hoặc chảy một phần";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Vấn đề mã vạch - thông tin hiển thị không đúng khi quét";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Khó quét/không quét được mã vạch";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Nhãn không rõ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Nhãn không chính xác";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Nhãn không đầy đủ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Các nhãn (sản phẩm, hộp/thùng, danh sách vận chuyển) có thông tin sản phẩm không trùng khớp nhau";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Nhãn quá tương tự với một sản phẩm khác";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Thiếu nhãn";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Thiếu mã vạch";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Nhận được sản phẩm bị đông đá";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Nhận được sản phẩm bị rã đông";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Có, có báo động nhưng không rõ là báo động gì";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Có (mô tả cụ thể ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Đúng - bộ chuyển tiếp không mở hoàn toàn được";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "ĐÚng - bộ chuyểnn tiếp không đóng hoàn toàn được";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Nắp vặn quá chặt nên bộ chuyển tiếp không thể mở được";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Nắp vặn quá chặt nên bộ chuyển tiếp không thể đóng được";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Thùng hay túi bảo vệ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Kẹp màu xanh trên ống đổ đầy cuối cùng";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Dây cassett";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Thiết bị kết nối ống xả và nắp khoen kéo";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Vùng lấy mẫu xả";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Các ống dẫn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Thiết bị kết nối đầu nhọn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Nhà tổ chức";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Nắp khoen kéo/Bảo vệ mũi nhọn trên ống dây kết nối với bệnh nhân";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Nắp khoen kéo/Bảo vệ mũi nhọn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Kẹp màu đỏ trên ống làm ấm";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Mối hàn";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Kẹp màu trắng trên ống cung cấp";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Bộ phận kết nối nguồn ống thông màu xám";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Cổng chíp";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Thiết bị kết nối màu xanh đậm";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Thân chính màu xanh nhạt";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Nắp khoen kéo màu xanh nhạt";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Chân chặn màu xanh nhạt";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Ống silicon";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Mũi nhọn titan";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "Mũi nhọn tia UV";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Nắp vặn màu trắng";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Có: mô tả hư hỏng (điền vào đây)";
translations[OPTION_MONTHOPTIONS_JAN] = "Tháng Một";
translations[OPTION_MONTHOPTIONS_FEB] = "Tháng Hai";
translations[OPTION_MONTHOPTIONS_MAR] = "Tháng Ba";
translations[OPTION_MONTHOPTIONS_APR] = "Tháng Bốn";
translations[OPTION_MONTHOPTIONS_MAY] = "Tháng Năm";
translations[OPTION_MONTHOPTIONS_JUN] = "Tháng Sáu";
translations[OPTION_MONTHOPTIONS_JUL] = "Tháng Bảy";
translations[OPTION_MONTHOPTIONS_AUG] = "Tháng Tám";
translations[OPTION_MONTHOPTIONS_SEP] = "Tháng Chín";
translations[OPTION_MONTHOPTIONS_OCT] = "Tháng Mười";
translations[OPTION_MONTHOPTIONS_NOV] = "Tháng Mười Một";
translations[OPTION_MONTHOPTIONS_DEC] = "Tháng Mười Hai";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Khác";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Khác";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Khác (điền vào đây)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Không phải các trường hợp trên";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Không";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Có";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Không";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Có";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Không";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Có";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Không";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Có";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Đã hỏi nhưng Không biết";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Không";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Không biết";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Có";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Không";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Có";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Không";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Có";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Không";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Có";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Không";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Có";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Không";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Có";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Không";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Có";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Không";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Có";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Không";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Có";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Không";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Có";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Không";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Có";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Không";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Có";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Không";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Có";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Không";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Có";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Không";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Không";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Có";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Không";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Có";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Không";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Có";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Không";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Có";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Không";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Có";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Không";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Có";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Không";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Có";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Không";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Có";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Không";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Có";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Không";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Có";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Không";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Không";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Có";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Không";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Có";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Không";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Có";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Không";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Không biết";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Có";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Không";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Có";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Không";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Có";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Không";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Có";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Không";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Có";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Không";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Không biết";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Có";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Không";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Có";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Không";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Có";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Không";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Có";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Không";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Có";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Không";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Có";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Không";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Có";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Không";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Có";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Không";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Có";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Không";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Có";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Không";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Không biết";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Có";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Không";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Có";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Không";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Có";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Không";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Có";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Không";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Có";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Không";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Có";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Không";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Có";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Không";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Có";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Không";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Có";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Không";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Có";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Có";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Không";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Có";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Không";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Có";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Không";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Có";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Không";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Có";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Không";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Có";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Không";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Có";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Không";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Có";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Không";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Có";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Không";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Có";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Không";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Có";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Sai";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Không";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Có";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Sai";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Không";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Có";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Không";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Có";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Không";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Có";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Không";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Có";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Sai";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Không";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Có";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "Sai";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Không";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Có";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Không";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Có";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Không";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Có";
translations[OPTION_GELPACKSOPTIONS_NO] = "Không";
translations[OPTION_GELPACKSOPTIONS_YES] = "Có";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Không";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Có";
translations[OPTION_ALARMOPTIONS_NO] = "Không";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Không";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Có";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Không";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Không";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Có";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Không";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Có";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Không";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Không biết";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Không";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Có";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Khác (điền vào đây)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Không";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Có";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Không";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Có";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Không";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Có";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Đã hỏi nhưng Không biết";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Đã hỏi nhưng Không biết";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "Sai";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Không phải các trường hợp trên";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Không - mô tả màu sắc (điền vào đây)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Đúng - Mô tả thiết bị đã dùng (điền vào đây)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Sự tách biệt";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Không cái nào";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Đúng - khác (điền vào đây)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Không";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogam";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Pound";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "Không";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Không biết";
translations[PLEASE_ENTER_THE_VALUE] = "Vui lòng nhập giá trị";
translations[PLEASE_SELECT_THE_VALUE] = "Vui lòng chọn giá trị";
translations[PLEASE_SELECT_THE_DATE] = "Vui lòng chọn ngày";
translations[PLEASE_CHOOSE_THE_VALUE] = "Vui lòng chọn giá trị";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Không biết";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "ANH";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "BẮC AI-LEN";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ĐẢO ALAND";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ANBANI";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ANGERI";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERICAN SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "NAM CỰC";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA AND BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "ÚC";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "ÁO";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BELARUS";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BỈ";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA AND HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET ISLAND";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITISH INDIAN OCEAN TERRITORY";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BUNGARI";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMPUCHIA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMEROON";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CAPE VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMAN ISLANDS";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "CENTRAL AFRICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "TRUNG QUỐC";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "CHRISTMAS ISLAND";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOS (KEELING) ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "CONGO, THE DEMOCRATIC REPUBLIC OF THE";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOK ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "CÔTE D'IVOIRE (IVORY COAST)";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROATIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPRUS";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "CỘNG HÒA SÉC";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "ĐAN MẠCH";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGYPT";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "EQUATORIAL GUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETHIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLAND ISLANDS (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FAROE ISLANDS";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "PHẦN LAN";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "PHÁP ";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRENCH GUIANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRENCH POLYNESIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRENCH SOUTHERN TERRITORIES";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "ĐỨC";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "HI LẠP";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GREENLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND AND MCDONALD ISLANDS";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HOLY SEE (VATICAN CITY STATE)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HỒNG KÔNG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HUNGARY";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ICELAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "ẤN ĐỘ";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMIC REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRELAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLE OF MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "Ý";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "NHẬT BẢN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDAN";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAKHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENYA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "CỘNG HÒA DÂN CHỦ NHÂN DÂN TRIỀU TIÊN";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "HÀN QUỐC";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KYRGYZSTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "CỘNG HÒA DÂN CHỦ NHÂN DÂN LÀO";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LATVIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LI BĂNG";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBYAN ARAB JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITHUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBOURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALAYSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVES";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALL ISLANDS";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIA, FEDERATED STATES OF";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDOVA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MOROCCO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "HÀ LAN";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NEW CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NEW ZEALAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLK ISLAND";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NORTHERN MARIANA ISLANDS";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NA UY";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINIAN TERRITORY, OCCUPIED";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEW GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "PHILIPPINES";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "BA LAN";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "BỒ ĐÀO NHA";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "RUMANI";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "LIÊN BANG NGA";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SAINT HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS AND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOVAKIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SOLOMON ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "NAM PHI";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "TÂY BAN NHA";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD AND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "THỤY ĐIỂN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "THỤY SĨ";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRIAN ARAB REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "ĐÀI LOAN";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, UNITED REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THÁI LAN";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD AND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNISIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "THỔ NHĨ KỲ";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS AND CAICOS ISLANDS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "CÁC TIỂU VƯƠNG QUỐC Ả RẬP THỐNG NHẤT";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "LIÊN HIỆP ANH";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "MỸ";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "UNITED STATES MINOR OUTLYING ISLANDS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIỆT NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "VIRGIN ISLANDS, BRITISH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "VIRGIN ISLANDS, U.S.";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTERN SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Không";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Không biết";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Có";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Tôi đã đọc và hiểu Thông báo về quyền riêng tư được liên kết cho Cổng thông tin phản hồi về sản phẩm Vantive.";
translations[PRODUCT_LOT] = "Số lô sản phẩm";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Nhãn vận chuyển / phân phối";
translations[CARTON_LABEL] = "Nhãn thùng carton";
translations[INTERNAL_PRODUCT_LABEL] = "Nhãn sản phẩm nội bộ";
translations[TITLE_PD_RENAL] = "PD thận";
translations[TITLE_SOLUTIONS] = "Các giải pháp";
translations[TITLE_ACCESS] = "Truy cập";
translations[TITLE_ALL_OTHER_PRODUCT] = "Tất cả sản phẩm khác";
translations[REPORTED_PROBLEM] = "Vấn đề được báo cáo";
translations[LOGIN] = "Đăng nhập";
translations[SYSTEM_MENU] = "Menu hệ thống";
translations[INITIATE_PRODUCT_FEEDBACK] = "Bắt đầu một phản hồi về sản phẩm";
translations[FEEDBACK_STATUS] = "Trạng thái phản hồi";
translations[OKTACALLBACK] = "OktaGọi lại";
translations[VALID_EMAIL] = "Vui lòng nhập địa chỉ email hợp lệ";
translations[VALID_NUMERIC] = "Vui lòng nhập toàn bộ số";
translations[PLEASE_UPLOAD_IMAGE] = "Vui lòng tải hình ảnh lên";
translations[VALID_DATE] = "Vui lòng chọn ngày hợp lệ";
translations[QUANTITY] = "lượng";
translations[EDIT] = "Chỉnh sửa";
translations[DELETE] = "Xóa bỏ";
translations[LOT_SERIAL_NO] = "Lô / Số sê-ri";
translations[LOT_NUMBER_NOT_FOUND] = "Không tìm thấy số lô";
translations[SEARCHING_LOT_NUMBER] = "Tìm số lô";
translations[PRODUCT_CODE_NOT_FOUND] = "Không tìm thấy mã sản phẩm";
translations[SEARCHING_PRODUCT_CODE] = "Tìm mã sản phẩm";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Tệp tin loại (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) không được chấp nhận";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "Tệp tin bạn đang đính kèm vượt quá giới hạn dung lượng. Vui lòng nén hoặc đính kèm một tập tin khác";
translations[IMAGE_ICON] = "Bấm vào biểu tượng hình ảnh để chọn phương án";
translations[LOGIN_TO_ACCOUNT] = "Đăng nhập vào tài khoản";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Đăng nhập vào tài khoản của bạn";
translations[PASSWORD] = "Mật khẩu";
translations[SIGN_IN] = "Đăng nhập";
translations[UNKNOWN] = "Không biết";
translations[ASKED_UNKNOWN] = "Đã hỏi nhưng Không biết";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Chọn quốc gia";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Tiếng Trung Quốc (Tiếng Trung Quốc rút gọn)";
translations[DUTCH] = "Tiếng hà lan";
translations[ENGLISH] = "Tiếng Anh";
translations[FRENCH] = "Tiếng Pháp";
translations[GERMAN] = "Tiếng Đức";
translations[ITALIAN] = "Tiếng Ý";
translations[JAPANESE] = "Tiếng Nhật";
translations[KOREAN] = "Tiếng Hàn Quốc";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Tiếng Quan Thoại (Tiếng Trung Quốc truyền thống)";
translations[POLISH] = "Tiếng Ba Lan";
translations[PORTUGUESE] = "Tiếng Bồ Đào Nha";
translations[SPANISH] = "Tiếng Tây Ban Nha";
translations[THAI] = "Tiếng Thái";
translations[TURKISH] = "thổ nhĩ kỳ";
translations[VIETNAMESE] = "Tiếng Việt";
translations[BROWSE] = "duyệt";
translations[FEEDBACK_SUBMITTED] = "Đã gửi phản hồi";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Phản hồi về sản phẩm của bạn đã được gửi thành công. Xin cảm ơn thông tin của bạn. Bạn sẽ nhận được một email chứa mã số tham khảo. Là nhà cung cấp các sản phẩm y khoa, sự hài lòng của khách hàng và phản hồi về sản phẩm của chúng tôi là thiết yếu để thực hiện mục tiêu mang đến những sản phẩm có chất lượng tốt nhất. Xin vui lòng liên hệ";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "nếu bạn có câu hỏi hoặc thông tin bổ sung.";
translations[CLOSE] = "Đóng";
translations[PATIENT_AGE] = "Tuổi của bệnh nhân";
translations[ENTER_AGE] = "nhập tuổi";
translations[PATIENT_DOB] = "Ngày sinh của bệnh nhân";
translations[RELEVANT_ATTACHMENTS] = "Vui lòng cung cấp tập tin đính kèm có liên quan";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Nhập thông tin xác thực vào tài khoản Vantive của bạn";
translations[GET_PRODUCT_DETAILS] = "Nhận chi tiết sản phẩm";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Sử dụng sơ đồ trên (hình 2) để xác định vị trí của sự cố được báo cáo";
translations[FACILITY_ADDRESS] = "Địa chỉ cơ sở";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Địa chỉ cơ sở khác";
translations[CHOOSE_PRODUCT_CODE] = "Vui lòng chọn Mã Sản phẩm cho Lô/Số Seri vừa nhập";
translations[DECLINE] = "Từ chối";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT ESTATIUS VÀ SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "RƯỢU CAM BÌ";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "PHÍA NAM SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "cho biết văn bản trợ giúp có sẵn cho trường này";
translations[YOUR_FIRST_NAME] = "Tên của bạn";
translations[YOUR_LAST_NAME] = "Họ của bạn";
translations[MY_FIRST_NAME] = "Tên của tôi";
translations[MY_LAST_NAME] = "Họ của tôi";
translations[PATIENT_FIRST_NAME] = "Tên bệnh nhân";
translations[PATIENT_LAST_NAME] = "Họ của bệnh nhân";
translations[REPORTER_FIRST_NAME] = "Tên người báo cáo";
translations[REPORTER_LAST_NAME] = "Họ người báo cáo";
translations[EMPLOYEE_FIRST_NAME] = "Tên nhân viên";
translations[EMPLOYEE_LAST_NAME] = "Họ Nhân Viên";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Tên liên hệ của khách hàng/ Người dùng cuối";
translations[END_USER_CUSTOMER_LAST_NAME] = "Họ liên hệ của khách hàng/ Người dùng cuối";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Tên người liên hệ bổ sung";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Họ người liên hệ bổ sung";
translations[COPYRIGHT] = "Bản quyền ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "Tất cả quyền đã được bảo đảm. Phiên bản";
translations[ADD_ADDITIONAL_CONTACT] = "Thêm liên hệ bổ sung";
translations[CONTACT_ME] = "Khách hàng không muốn được liên lạc. Liên hệ với tôi cho bất kỳ câu hỏi bổ sung.";
translations[DO_NOT_CONTACT] = "Không liên lạc";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Tên cơ sở của khách hàng/ Người dùng cuối";
translations[END_USER_CUSTOMER_PHONE] = "Số điện thoại cơ sở của người dùng cuối/khách hàng";
translations[END_USER_CUSTOMER_EMAIL] = "Địa chỉ email của người dùng cuối/khách hàng";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Địa chỉ cơ sở của khách hàng/ Người dùng cuối";
translations[SAME_AS_PATIENT_ADDRESS] = "Giống Địa chỉ bệnh nhân";
translations[SAME_AS_REPORTER_ADDRESS] = "Giống Địa chỉ của người báo cáo";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Giống Địa chỉ cơ sở của khách hàng/ Người dùng cuối";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Sử dụng biểu đồ trên (Hình 3) để quyết định vị trí của sự cố đã báo cáo";
translations[CONTACT_US] = "Liên hệ chúng tôi";
translations[LANDING_BRIEF_FOR_DEVICE] = "Để yêu cầu hỗ trợ kỹ thuật, dịch vụ sửa chữa máy, linh kiện, vui lòng liên hệ đội Hỗ trợ kỹ thuật tại địa phương";
translations[PATIENT_SEX] = "Tình dục bệnh nhân";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Đàn ông/cậu bé chuyển giới";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Người phụ nữ/cô gái chuyển giới";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Người chuyển giới nam/chuyển giới nam/từ nữ sang nam";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Người chuyển giới nữ/chuyển giới nữ/từ nam sang nữ";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Danh mục giới tính khác; Xin hãy chỉ ra cụ thể";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Từ chối trả lời";
translations[ATTENTION_NEEDED] = "!!! CẦN CHÚ Ý KHẨN CẤP: Việc gửi Cổng thông tin phản hồi sản phẩm của bạn đã THẤT BẠI!";
translations[SUBMIT_ERR_MSG] = "Để gửi lại, vui lòng nhấp vào OK và sau đó Gửi Hoặc, gửi đơn khiếu nại của bạn qua email tới (@@@).";
translations[SUBMIT_RETRY_MSG] = "Nếu bạn gửi lại, vui lòng xác minh rằng bạn đã nhận được e-mail xác nhận trong hộp e-mail của bạn từ Cổng thông tin phản hồi sản phẩm. Nếu không nhận được email xác nhận, việc gửi không thành công và bạn PHẢI gửi khiếu nại qua email tới (@@@).";
translations[OK] = "OK";

export default lang;